<script setup lang="ts">
  import getDomains from '@/utils/getDomains'
  import EduApp from './EduApp.vue'
  import OfflinePage from './OfflinePage.vue'

  defineOptions({ name: 'App' })

  /** 教育版沿用下线前的站点逻辑，主站展示维护页 */
  const isEdu = getDomains().thirdLevelDomain === 'edu'
</script>

<template>
  <EduApp v-if="isEdu" />
  <OfflinePage v-else />
</template>
